
export class Covid19PoolSampleInfo {
    redoBatches: string;
    clippingBatch: string;
    customersBarcode: string;
    clippingBatchRow: string;
    clippingBatchCol: string;
    analysisBatch: string;
    contamination: string;
    results: any[];
    sender: string;
    documentBarcode: string;
    positionCol: string;
    comment: any[];
    channelTestingTypeMapping: any[];
    unboxedBatch: string;
    barcode: string;
    boxId: string;
    positionRow:string;
    unboxedSender: string;
    status:string;
    shippedUserPUID:string;
    shippedTimestamp: Date;
    destination: string;

}

